import BasePolicy from '@/policies/BasePolicy.js';

export default class AttendanceScenarioPolicy extends BasePolicy {
    // Attend admin surfaces stay hidden, even from super admins, until the user is granted the
    // ATTEND flag. A navigation projection only; the API gates every call on the same flag.
    before(user) {
        if (!user?.hasActiveFeature?.(window.__INITIAL_STATE__?.Features?.ATTEND)) {
            return false;
        }

        return super.before(user);
    }

    viewAny(user) {
        const permission = 'view all attendance scenarios';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    create(user) {
        const permission = 'create a attendance scenario';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    update(user) {
        const permission = 'edit a attendance scenario';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    delete(user) {
        const permission = 'delete a attendance scenario';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    configure(user) {
        return this.create(user) || this.update(user);
    }
}
